import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[92vh] flex items-center justify-center px-4 sm:px-6 pt-24 pb-16 text-center" data-testid="payment-cancel-page">
      <div>
        <XCircle className="h-16 w-16 text-smoke mx-auto" />
        <h1 className="font-anton uppercase tracking-tighter text-cream text-3xl sm:text-4xl mt-6">Checkout Cancelled</h1>
        <p className="text-smoke mt-3 max-w-md">No charge was made. You can pick up right where you left off whenever you're ready.</p>
        <div className="flex flex-col sm:flex-row gap-4 mt-8 justify-center">
          <Button asChild className="rounded-none bg-gold text-void hover:bg-gold-hover font-bold uppercase tracking-wider" data-testid="payment-cancel-membership-button">
            <Link to="/membership">View Membership</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-none border-gold text-gold hover:bg-gold hover:text-void" data-testid="payment-cancel-home-button">
            <Link to="/">Back Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
